var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import React, { useRef } from 'react';
var SearchBar = function (_a) {
    var placeholder = _a.placeholder, query = _a.query, setQuery = _a.setQuery, className = _a.className;
    var inputRef = useRef(null);
    var handleChangeQuery = function (event) {
        setQuery(event.target.value);
    };
    var handleSubmit = function (event) {
        event.preventDefault();
        if (inputRef.current) {
            inputRef.current.blur();
        }
    };
    return (_jsx("form", __assign({ className: className, onSubmit: handleSubmit }, { children: _jsxs("div", __assign({ className: "relative" }, { children: [_jsx("input", { ref: inputRef, id: "search", name: "search", className: "cursor-pointer block w-full rounded-md border-none bg-white md:mb-2 mb-3 py-1.5 pl-3 pr-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm sm:leading-6", placeholder: placeholder, type: "search", onChange: handleChangeQuery, value: query }), !query && (_jsx("div", __assign({ className: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3" }, { children: _jsx(MagnifyingGlassIcon, { className: "h-5 w-5 md:h-4 md:w-4 sm:w-4 sm:h-4 text-gray-400", "aria-hidden": "true" }) })))] })) })));
};
export default SearchBar;
